export default __webpack_public_path__ + "static/images/rapid-order-entry.c2424405.png";